

export const wanHero = {
    title: 'Wan 2.5: AI Video Generator with Native Audio',
    sub: 'Synchronized Sound • Lip-Sync Speech • Dynamic Visuals • Creative Freedom',
    desc:
      'Alibaba\'s breakthrough Wan 2.5 model generates videos with native audio – speech, music, and sound effects synchronized to visuals. Create 10-second videos from text or images in 720p/1080p. Maximum creative freedom for bold, dynamic content. No audio post-production needed.'
  };
